enum RouteEndpointsOrders {
  BASE_ORDERS = '/order-management',
  EDIT_ORDER = 'edit/:id',
  ADD_ORDER = 'add',
  DETAIL_ORDER = 'detail/:id',
  DETAIL_LEGACY = '/legacies/:legacyId',
}

export default RouteEndpointsOrders;
